export default __webpack_public_path__ + "static/bg_header_morning-6eab42a54a1468eab86152d4f189c712.svg";